import React, {FunctionComponent} from "react";


const styles = require('./klearLogo.component.scss');

interface KlearLogoProps {
    logoType?: 'primary' | 'secondary' | 'tertiary';
    size?: 'large' | 'medium' | 'small';
    color?: 'white' | 'black' | 'gray';
}

export const KlearLogo: FunctionComponent<KlearLogoProps> = props => {
    const {logoType, size, color} = props;

    return (
        <div className={styles.container}>
            <div className={`${styles.diamondContainer} ${logoType ? styles[logoType] : styles.primary} ${size ? styles[size] : styles.large} ${color ? styles[color] : styles.gray}`}>
                <img className={styles.imageContainer} src={'/images/new/logo/klear_logo.png'} alt={''}/>
            </div>
        </div>
    )
}
